'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

exports.default = InputGroup;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _uiComponents = require('@wh/ui-components');

var _inputPassword = require('../input-password');

var _inputPassword2 = _interopRequireDefault(_inputPassword);

var _utils = require('./utils');

var _constants = require('./../constants');

require('./input-group.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Input group component
 * @param {InputGroupPropsType} props The properties object.
 * @returns {Element} React element
 * @constructor
 */
function InputGroup(props) {
    var inputProps = (0, _pick2.default)(props, ['t', 'type', 'placeholder', 'label', 'id', 'autoCapitalize', 'autoComplete', 'autoCorrect', 'isAutofocused', 'isSpellchecked', 'onKeyDown', 'refCallback', 'trackingEvent']);
    var input = props.input,
        meta = props.meta;


    var inputClassNames = (0, _classnames2.default)({
        error: (0, _utils.checkIfError)(input, meta),
        success: (0, _utils.checkIfSuccess)(input, meta)
    });

    var componentClassNames = (0, _classnames2.default)('c-login-form__input-group', {
        'c-login-form__input-group--password': inputProps.type === 'password'
    });

    var InputComponent = inputProps.type === 'password' ? _inputPassword2.default : _uiComponents.Input;

    var trackInlineErrorEvent = function trackInlineErrorEvent(inputData, metaData) {
        if (metaData.invalid) {
            inputProps.trackingEvent(_constants.TRACKING_EVENT_NAME_FORM_ERROR_INLINE, {
                errorMessageName: metaData.error.code
            });
        }
    };

    var errorMessage = (0, _utils.checkIfError)(input, meta) ? (0, _jsx3.default)('p', {
        className: 'c-login-form__input-group-error'
    }, void 0, inputProps.t('login')(meta.error.message)) : null;

    var onBlur = function onBlur(event) {
        input.onBlur(event);
        trackInlineErrorEvent(input, meta);
    };

    return (0, _jsx3.default)('div', {
        className: componentClassNames
    }, void 0, (0, _jsx3.default)(_uiComponents.FormLabel, {
        htmlFor: inputProps.id
    }, void 0, inputProps.label), _react2.default.createElement(InputComponent, (0, _extends3.default)({}, input, inputProps, {
        onBlur: onBlur,
        style: inputClassNames
    })), errorMessage);
}
//# sourceMappingURL=input-group.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/input-group/input-group.js
// module id = 480
// module chunks = 0